import { useWebSiteStore } from '@/stores/web-site.store'
import { useGarageStore } from '@/stores/garage.store'
import { useRegistryStore } from '@/stores/registry.store'
import { usePortalStore } from '@/stores/portal.store'

import { fixedDecimal } from '@/lib/utils'

export const usePriceService = () => {
  const webSiteStore = useWebSiteStore()
  const garageStore = useGarageStore()
  const registryStore = useRegistryStore()
  const portalStore = usePortalStore()

  const getTotalNoVatValue = (data) => {
    if (!data.price || !data.quantity || data.cost_valorization === garageStore.costValorizationsEnum.WARRANTY || data.cost_valorization === garageStore.costValorizationsEnum.FREE) {
      return 0
    }
    let total = data.quantity * data.price
    if (data.discount) {
      total = total * (1 - data.discount)
    }
    if (data.discount_2) {
      total = total * (1 - data.discount_2)
    }
    if (data.discount_3) {
      total = total * (1 - data.discount_3)
    }
    if (data.urgency_discount) {
      total = total * (1 - data.urgency_discount)
    }
    if (data.urgency_discount_2) {
      total = total * (1 - data.urgency_discount_2)
    }
    return fixedDecimal(+total)
  }

  const getTotalVatValueFromPriceVat = (data) => {
    if (!data.price_vat || !data.quantity || data.cost_valorization === garageStore.costValorizationsEnum.WARRANTY || data.cost_valorization === garageStore.costValorizationsEnum.FREE) return 0
    let total = data.quantity * data.price_vat
    if (data.discount) total *= (1 - data.discount)
    if (data.discount_2) total *= (1 - data.discount_2)
    if (data.discount_3) total *= (1 - data.discount_3)
    if (data.urgency_discount) total *= (1 - data.urgency_discount)
    if (data.urgency_discount_2) total *= (1 - data.urgency_discount_2)
    return fixedDecimal(+total)
  }

  const getTotalVatValue = (data) => {
    if (!data.vat_type_ref) {
      return getTotalNoVatValue(data)
    }
    if (data.vat_type_ref && !data.vat_type_percentage) {
      data.vat_type_percentage = getVatById(data.vat_type_ref).percentage
    }
    const d = +(getTotalNoVatValue(data) * (1 + (data.vat_type_percentage)))
    return Math.round((d + Number.EPSILON) * 100) / 100
  }

  const getVatById = (id) => {
    return webSiteStore.vatTypes.find(i => i.id === id)
  }

  const getIncludesVatValue = (customer) => {
    if (registryStore.companyData.default_worksheet_document_price_type === portalStore.documentPriceTypes.CUSTOMER && !!customer) {
      return registryStore.subjectTypes.find(i => i.id === customer.subject_type_ref)?.code === 'P'
    }
    return registryStore.companyData.default_worksheet_document_price_type === 0
  }

  return {
    getTotalNoVatValue,
    getTotalVatValueFromPriceVat,
    getTotalVatValue,
    getIncludesVatValue,
  }
}
